"use client";

import { Toaster, toast } from "sonner";

/**
 * ToastProvider component
 *
 * This component provides a toast notification system using the `sonner` library.
 * It shows a generic error message when something goes wrong.
 */
export default function ToastProvider() {
  return <Toaster position="top-right" expand={false} richColors closeButton />;
}

/**
 * Shows a generic error toast notification.
 */
export const showErrorToast = () => {
  toast.error("Something went wrong!", {
    description: "Please try again or refresh the page.",
  });
};
